import { observable, action } from "mobx";
import { post } from "../../services/ajax-calls.service";

class MedicalMedicareLookupStore {

  @observable medicare_lookup = [];
  @observable errors = {};
  @observable url = "/api/v1/medicalActions/medicarelookup";

  @action get_medicare_price = async data => {
    this.medicare_lookup = [];
    try {
      let response = await post(
        `${this.url}/get_medicare_price`,
        data
      );
      this.errors = {}
      this.medicare_lookup = response.data;
    } catch (err) {
      this.errors = err.response.data;
      return this.errors
    }
  };

}

export default MedicalMedicareLookupStore;
